export const ApplicationType = {
  SELF_HOSTED: "SELF_HOSTED",
  MANAGED: "MANAGED",
  SHARED_POOL: "SHARED_POOL",
} as const;

export type ApplicationTypeType =
  (typeof ApplicationType)[keyof typeof ApplicationType];

export const ApplicationStatus = {
  UNDER_REVIEW: "UNDER_REVIEW",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
  STACKED: "STACKED",
  PROVISIONING: "PROVISIONING",
  NODE_ASSIGNED: "NODE_ASSIGNED",
  UNSTACKED: "UNSTACKED",
  UNSTACKED_SUBMITTED: "UNSTACKED_SUBMITTED",
  UNSTACKED_PROCESSING: "UNSTACKED_PROCESSING",
  UNSTACKED_PROCESSED: "UNSTACKED_PROCESSED",
  UNSTACKED_CANCELLED: "UNSTACKED_CANCELLED",
  UNSTACKED_WITHDRAWN: "UNSTACKED_WITHDRAWN",
} as const;

export type ApplicationStatusType =
  (typeof ApplicationStatus)[keyof typeof ApplicationStatus];

export const ApplicationTxStatus = {
  PENDING: "PENDING",
  CONFIRMED: "CONFIRMED",
  FAILED: "FAILED",
} as const;

export type ApplicationTxStatusType =
  (typeof ApplicationTxStatus)[keyof typeof ApplicationTxStatus];
